import { PropsWithChildren } from 'react';

import { clientModules } from '@/clientModules';

export default function AuthProvider({ children }: PropsWithChildren) {
  return clientModules.authentication.AuthProvider ? (
    <clientModules.authentication.AuthProvider>{children}</clientModules.authentication.AuthProvider>
  ) : (
    children
  );
}
